import * as types from './ActiveFiltersActionTypes.js';

export const setGraphOverviewFiltersAction = (filters) => {
    return {
        type: types.SET_GRAPHOVERVIEWFILTERS,
        payload: filters
    };
};

export const setProjectOverviewFiltersAction = (filters) => {
    return {
        type: types.SET_PROJECTOVERVIEWFILTERS,
        payload: filters
    };
};

export const resetActiveFilters = () => {
    return {
        type: types.RESET_ACTIVEFILTERS
    };
};
